import React from 'react';
import {useHistory} from 'react-router-dom';
import {useCurrentUser} from '../hooks/user';
import {fetchUserInfo} from '../store/user/actions';
import {useDispatch} from 'react-redux';
import {createOffersManagementUrl} from '../utils/navigation';
import {AlertType} from '../common/types';

interface IosPushNotifierProps {
}

const IosPushHandler: React.FC<IosPushNotifierProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch();


  const updateUserInfo = () => {
    dispatch(fetchUserInfo());
  }

  // @ts-ignore
  window.handlePushNotification = function (data: any) {
    console.log('Push notification received:', data);
    alert(JSON.stringify(data));
    if(data == 'payment'){
      history.push('/payment');
    }
  }
  // @ts-ignore
  window.handleIosPaymentSuccess = function (data: any) {
    updateUserInfo();
    history.push(createOffersManagementUrl({alertType: AlertType.PaymentSuccessful, alertPayload: data}));
    console.log('Payment success received:', data);
  }
  return null;
};

export default IosPushHandler;
